export default __webpack_public_path__ + "static/media/startnat.c993aef6.png";